import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CareerRoleActivationStatus, CareerRoleSummaryListItemResponse } from '../../../models';
export interface CareerRoleListQuery {
  page: number;
  pageSize: number;
  searchText?: string;
  activeOnly: boolean;
}
@Component({
  selector: 'app-career-role-list',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatTooltipModule
  ],
  templateUrl: './career-role-list.component.html',
  styleUrl: './career-role-list.component.scss'
})
export class CareerRoleListComponent {
  private readonly fb = inject(FormBuilder);
  @Input() items: CareerRoleSummaryListItemResponse[] = [];
  @Input() totalCount = 0;
  @Input() loading = false;
  @Input() compact = false;
  @Output() load = new EventEmitter<CareerRoleListQuery>();
  @Output() openRole = new EventEmitter<string>();
  readonly form = this.fb.nonNullable.group({
    page: [1, [Validators.required, Validators.min(1)]],
    pageSize: [10, [Validators.required, Validators.min(1), Validators.max(100)]],
    searchText: [''],
    activeOnly: [false]
  });
  submit(): void {
    if (this.form.invalid || this.loading) {
      return;
    }
    const raw = this.form.getRawValue();
    this.load.emit({
      page: raw.page,
      pageSize: raw.pageSize,
      searchText: raw.searchText.trim() || undefined,
      activeOnly: raw.activeOnly
    });
  }
  onOpenRole(roleSlug: string): void {
    this.openRole.emit(roleSlug);
  }

  activationStatusLabel(status?: CareerRoleActivationStatus, active?: boolean): string {
    if (status) {
      return status.charAt(0).toUpperCase() + status.slice(1);
    }
    return active ? 'Active' : 'Inactive';
  }

  isEngaged(status?: CareerRoleActivationStatus, active?: boolean): boolean {
    return status === 'active' || status === 'activating' || !!active;
  }
}
